<template>
<!-- Navigation -->
    <nav>
        <div class="container">
            <a href="#home" class="nav-logo">Sumantha Chandrashekara</a>
            <ul class="nav-links">
                <li><a href="https://www.linkedin.com/in/ahtnamus/" target="_blank" title="LinkedIn"><i class="fab fa-linkedin-in"></i></a></li>
                <li><a href="mailto:ahtnamus@gmail.com" title="Email"><i class="far fa-envelope"></i></a></li>
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
  name: 'HeaderComponent'
}
</script>

<style scoped>

</style>